module.exports = __webpack_public_path__ + "static/media/27000family.f9915f84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/27000family.png
// module id = 1664
// module chunks = 0